import { TEMPLATE_CATEGORIES_SUFFIXES } from '../../constants/templates.constants';
import DossierTemplates from '../../containers/dossier-templates/DossierTemplates';
import { getTemplateCategory } from '../../lib/template.utils';
import AttachmentsList from '../attachments/AttachmentsList';

const DossierCasetafelAttachments = ({
  dossierType,
  loadingAttachments,
  attachments = [],
  reports = [],
  onAttachmentAdd,
  onAttachmentOpen,
  onReportAdd,
  onReportOpen,
  isCommission,
  read,
  readReportOnly,
  write,
  writeApproveAndQuestionnaireOnly
}) => {
  if (!read) {
    return null;
  }

  return (
    <>
      {!readReportOnly && (
        <AttachmentsList
          className="u-margin-bottom-lg"
          title={isCommission ? 'Commissie' : 'Casetafel'}
          attachments={attachments}
          loading={loadingAttachments}
          noAttachmentsText="Er zijn momenteel nog geen bestanden toegevoegd."
          onOpen={onAttachmentOpen}
          onUpload={write ? onAttachmentAdd : undefined}
          templates={
            write && (
              <DossierTemplates
                category={getTemplateCategory(
                  dossierType,
                  isCommission
                    ? TEMPLATE_CATEGORIES_SUFFIXES.COMMISSION_PREPARATION
                    : TEMPLATE_CATEGORIES_SUFFIXES.CASETABLE_PREPARATION
                )}
              />
            )
          }
        />
      )}
      <AttachmentsList
        className="u-margin-bottom-lg"
        title={isCommission ? 'Advies commissie' : 'Terugkoppeling casetafel'}
        attachments={reports}
        loading={loadingAttachments}
        noAttachmentsText="Er zijn momenteel nog geen bestanden toegevoegd."
        onOpen={onReportOpen}
        onUpload={write ? onReportAdd : undefined}
        templates={
          write &&
          !writeApproveAndQuestionnaireOnly &&
          onReportAdd && (
            <DossierTemplates
              category={getTemplateCategory(
                dossierType,
                isCommission
                  ? TEMPLATE_CATEGORIES_SUFFIXES.COMMISSION_REPORT
                  : TEMPLATE_CATEGORIES_SUFFIXES.CASETABLE_REPORT
              )}
            />
          )
        }
      />
    </>
  );
};

export default DossierCasetafelAttachments;
